module.exports = __webpack_public_path__ + "static/duke-fc9f8981b69992c49f9c5032bd6ea304.png";